import React from "react";
import { BrainIcon, TimerIcon, MapIcon, SearchIcon, ClipboardListIcon, BoxIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { tools, ToolIcon } from "../data/content";
const iconMap: Record<ToolIcon, BoxIcon> = {
  brain: BrainIcon,
  timer: TimerIcon,
  map: MapIcon,
  search: SearchIcon,
  clipboard: ClipboardListIcon
};
export function ToolsSection() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="tools-title" data-id="element-307" data-mp="2vrm8o7w7jso9">
      <div className="mx-auto max-w-3xl" data-id="element-308" data-mp="2qt1a0cwlth1x">
        <h2 id="tools-title" className="text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-309" data-mp="2qucmr2811z56">
          You'll also get <em className="text-wine-700" data-id="element-310" data-mp="34qpvnmyhws81">immediate access</em> to:
        </h2>

        <ul className="mt-10 divide-y divide-wine-100" data-id="element-311" data-mp="2zs67rh0cd6d1">
          {tools.map(({
          icon,
          title,
          text
        }) => {
          const Icon = iconMap[icon];
          return <li key={title} className="flex gap-4 py-5" data-id="element-312" data-mp="f2p852j8h1yp">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-wine-100 text-wine-700" data-id="element-313" data-mp="2i6bsld8yhf5u">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-314" data-mp="2m6m3937p0tr1" />
                </span>
                <div data-id="element-315" data-mp="2r6gtd4jn9fb1">
                  <h3 className="text-lg font-bold leading-snug text-ink" data-id="element-316" data-mp="2r81jmhyxec33">{title}</h3>
                  <p className="mt-1 text-[16px] leading-relaxed text-ink-soft" data-id="element-317" data-mp="2w4s2te611nsq">{text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>

      <div className="mx-auto mt-12 max-w-4xl rounded-3xl bg-wine-900 px-6 py-12 text-center sm:px-12 sm:py-16" data-id="element-318" data-mp="23h5pvfawt6t7">
        <p className="font-serif text-3xl font-bold leading-tight text-white sm:text-4xl" data-id="element-319" data-mp="28fqpbcic7mgl">The goal isn't to memorize 50 answers.</p>
        <p className="mt-3 font-serif text-2xl font-bold italic leading-snug text-wine-200 sm:text-3xl" data-id="element-320" data-mp="2d7qtxi9cr3ji">
          It's to finish the 50 cases knowing how to ask better questions.
        </p>
        <div className="mt-8" data-id="element-321" data-mp="1kpmnnaoplws8">
          <CtaButton label="I want access to the War Room" data-id="element-322" data-mp="1kol9uygb6w6t" />
        </div>
      </div>
    </section>;
}